import { ResponsiveMode, useResponsiveMode } from "@fluentui/react";
import { createRef } from "react";

type IUseResponsiveHook = {
  currentWindowSize: ResponsiveMode;
  isLargeWindow: boolean;
  isSmallWindow: boolean;
};

/**
 * A custom hook used to aid in creating responsive layouts.
 *
 * @returns an object describing the current ResponsiveMode
 * representing the current size of the window, and a boolean
 * property describing whether it's a large window.
 */
export const useResponsiveWindow = (): IUseResponsiveHook => {
  const ref = createRef<HTMLElement>();
  const responsiveMode = useResponsiveMode(ref);

  return {
    currentWindowSize: responsiveMode,
    isLargeWindow: responsiveMode > ResponsiveMode.xLarge,
    isSmallWindow: responsiveMode <= ResponsiveMode.xLarge,
  };
};
